module.exports = __webpack_public_path__ + "img/centrum-coffee-closeup.fc808e0a.jpg";